const Footer = () => {
    return (
        <div className="flex w-full flex-col items-center justify-between px-1 pb-8 pt-3 lg:px-8 xl:flex-row">
            <p className="mb-4 font-geist text-sm text-leadrs-text-soft sm:mb-0">
                &copy;{new Date().getFullYear()} Leadrs.co. All Rights Reserved.
            </p>
            <ul className="flex flex-wrap items-center gap-3 sm:flex-nowrap md:gap-6">
                <li>
                    <a
                        target="blank"
                        href="https://go.crisp.chat/chat/embed/?website_id=d7156788-8d6d-40b5-ba31-f28c6b9dd7b0"
                        className="font-geist text-sm text-leadrs-text-soft transition-colors hover:text-leadrs-text"
                    >
                        Support
                    </a>
                </li>
                <li>
                    <a
                        target="blank"
                        href="https://app.leadrs.co/Mentions%20L%C3%A9gales.pdf"
                        className="font-geist text-sm text-leadrs-text-soft transition-colors hover:text-leadrs-text"
                    >
                        Mentions légales
                    </a>
                </li>
                <li>
                    <a
                        target="blank"
                        href="https://app.leadrs.co/CGV.pdf"
                        className="font-geist text-sm text-leadrs-text-soft transition-colors hover:text-leadrs-text"
                    >
                        CGV
                    </a>
                </li>
                <li>
                    <a
                        target="blank"
                        href="https://app.leadrs.co/CGU.pdf"
                        className="font-geist text-sm text-leadrs-text-soft transition-colors hover:text-leadrs-text"
                    >
                        Conditions d&apos;utilisation marketplace
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default Footer;
